import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useContext } from 'react';
import { LinkWrapper } from '../../OnePagePayuPaymentV2.styles';
import { generateLinkToProductPage } from '@/common/functions/generateLinkToProductPage';
import { LanguageContext } from '@/common/contexts/LanguageContext';

const Rules = () => {
	const translations = useLanguageData('checkout');
	const common = useLanguageData('common');
	const { lang } = useContext(LanguageContext);

	return (
		<LinkWrapper style={{ display: 'flex', alignItems: 'center' }}>
			<input type='checkbox' id='rules_2' required defaultChecked />
			<label
				htmlFor='rules_2'
				style={{
					cursor: 'pointer',
					display: 'flex',
					flexWrap: 'wrap',
					gap: '3px',
					maxWidth: '300px',
					padding: '0 0 0 5px ',
				}}
			>
				{translations.accept}{' '}
				<a
					href={generateLinkToProductPage(lang, common.termsLink)}
					style={{ textDecoration: 'underline' }}
				>
					{' '}
					{translations.rules}
				</a>
				{translations.space}
				<a
					href={generateLinkToProductPage(lang, common.privacyLink)}
					style={{
						textDecoration: 'underline',
					}}
				>
					{translations.tos}
				</a>
				SynthiAi
			</label>
		</LinkWrapper>
	);
};

export default Rules;
